export default function getInputElementCaretPosition(ele) {
  if (ele.selectionStart != null) {
    return ele.selectionStart;
  } else if (document.selection != null) {
    ele.focus();
    const r = document.selection.createRange();
    const re = ele.createTextRange();
    const rc = re.duplicate();
    re.moveToBookmark(r.getBookmark());
    rc.setEndPoint('EndToStart', re);
    return rc.text.length;
  }
  return undefined;
}
